import React, { Component } from 'react';
import MonthlyReportComponent from '../components/monthlyReportComponent';
import {UpdateReportTypeSettings,PerRegionExcelMail,PerRegionPdfMail,getAllRegionSettings, getAllMonthlyReport,getAllUsers,getAllAlarm} from '../action/monthlyReportAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class MonthlyReportContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
       
        this.props.actions.getAllRegionSettings();
         
      /*   setTimeout(
            () => this.getMonthlyReport({
            RegionId:this.props.MonthlyReportData.regionList[0].ID
         }),
            400
        ); */
        
    }
    getRegion = () =>{
        this.props.actions.getAllRegionSettings(
            this.props.dispatch
        )
        
    }
  
   getRegionData = () => {
          this.props.actions.getAllRegionSettings(this.props.dispatch);
       } 
   
    getMonthlyReport = (data) =>{
        this.props.actions.getAllMonthlyReport(data,
            this.props.dispatch
        )
    }
  
   getMonthlyReportData = (data) => {
          this.props.actions.getAllMonthlyReport(data,this.props.dispatch);
       } 
   
  
   getAllUsersData = (data) => {
          this.props.actions.getAllUsers(data,this.props.dispatch);
       } 
       getAllAlarmData = (data) => {
          this.props.actions.getAllAlarm(data,this.props.dispatch);
       } 
       PerRegionPdfEmail = (item) => {
                  this.props.actions.PerRegionPdfMail(
                      item,
                      this.props.dispatch
                  )
              }
    PerRegionExcelEmail = (item) => {
                  this.props.actions.PerRegionExcelMail(
                      item,
                      this.props.dispatch
                  )
              }
    UpdateReportTypeSetting = (item) => {
                  this.props.actions.UpdateReportTypeSettings(
                      item,
                      this.props.dispatch
                  )
              }
    render(){
        
        return(
            <div >
                <MonthlyReportComponent
                    MonthlyReportDetails = {this.props.MonthlyReportData}
                    getRegion ={this.getRegion}
                    getRegionList={this.getRegionData}
                    getMonthlyReport ={this.getMonthlyReport}
                    getMonthlyReportList={this.getMonthlyReportData}
                    getUserList={this.getAllUsersData}
                    getAlarmList={this.getAllAlarmData}
                    PerRegionPdfEmail={this.PerRegionPdfEmail}
                    PerRegionExcelEmail={this.PerRegionExcelEmail}
                    UpdateReportTypeSetting={this.UpdateReportTypeSetting}
                >
                </MonthlyReportComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllRegionSettings,
          getAllMonthlyReport,
          getAllUsers,
          getAllAlarm,
          PerRegionPdfMail,
         PerRegionExcelMail,
         UpdateReportTypeSettings
        },
            dispatch)
    };
}
function mapStateToProps({ MonthlyReportReducer }) {
    console.log(MonthlyReportReducer);
    return {
        MonthlyReportData : {
            errorCode : MonthlyReportReducer.errorCode,
            statusCode : MonthlyReportReducer.statusCode,
            regionList : MonthlyReportReducer.regionList,
            message : MonthlyReportReducer.message,
            lifeGuardAlarm: MonthlyReportReducer.lifeGuardAlarm,
            usersList:MonthlyReportReducer.usersList,
            alarmList:MonthlyReportReducer.alarmList
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MonthlyReportContainer));